import { composeValidators, isVersion, required } from 'tools/validationRules';

export const validations = {
    version: composeValidators(required, isVersion),
    required: composeValidators(required),
};
